export default __webpack_public_path__ + "static/media/oprah2x.5a5a1be1.png";